import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import styles from "../OrderDetailsNewVersion.module.scss";
import crStyles from "../../../customerReservation/crStyles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import {
  StyledBasicExpansionPanel,
  StyledBasicExpansionPanelSummary,
} from "../../../../shared/ExpansionPanels/ExpansionPanel";
import SpecsRow from "../SpecsRow";
import { formatEUPriceValue } from "../../../../utils/FormatPrice";

class PrivateLeaseBreakdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandCashBreakdown: false,
      expandConfiguredOptions: false,
      expandTotalSavings: false,
      expandCharging: false,
      expandAccessories: false,
      expandProtectionPlans: false,
    };
    this.rowCounter = 0;
  }

  expandCashBreakdown() {
    this.rowCounter = 0;
    this.setState((prevState) => ({
      expandCashBreakdown: !prevState.expandCashBreakdown,
    }));
  }

  expandConfiguredOptions() {
    this.rowCounter = 0;
    this.setState((prevState) => ({
      expandConfiguredOptions: !prevState.expandConfiguredOptions,
    }));
  }

  expandTotalSavings() {
    this.rowCounter = 0;
    this.setState((prevState) => ({
      expandTotalSavings: !prevState.expandTotalSavings,
    }));
  }

  expandCharging() {
    this.rowCounter = 0;
    this.setState((prevState) => ({
      expandCharging: !prevState.expandCharging,
    }));
  }

  expandAccessories() {
    this.rowCounter = 0;
    this.setState((prevState) => ({
      expandAccessories: !prevState.expandAccessories,
    }));
  }

  expandProtectionPlans() {
    this.rowCounter = 0;
    this.setState((prevState) => ({
      expandProtectionPlans: !prevState.expandProtectionPlans,
    }));
  }

  getRowColor = () => {
    this.rowCounter += 1;
    return this.rowCounter % 2 === 0
      ? styles.darkCaseSensitiveHeader
      : styles.lightCaseSensitiveHeader;
  };

  formatPriceValue = (value) => {
    const defaultCurrency = this.props.localizedInfo.defaultCurrency.symbol;
    return formatEUPriceValue(value, defaultCurrency);
  };

  render() {
    const financeDataQuote = this.props.customerReservation.financeDataQuote;
    const paymentType = this.props.customerReservation.paymentType;

    return (
      <StyledBasicExpansionPanel
        expanded={this.state.expandCashBreakdown}
        disabled={false}
        onChange={() => this.expandCashBreakdown()}
        data-testid="privateLeaseExpansionPanel"
      >
        <StyledBasicExpansionPanelSummary
          style={crStyles.orderDetailsExpansion}
          id="exp"
        >
          <div className={styles.headerBar}>
            <div className={styles.header}>
              {this.props.t("PaymentMethod.privateLease")}
            </div>
            {this.state.expandCashBreakdown ? (
              <ExpandLessIcon id="less" />
            ) : (
              <ExpandMoreIcon id="more" />
            )}
          </div>
          <br />
        </StyledBasicExpansionPanelSummary>
        <div>
          <SpecsRow
            priceDetails={this.props.t("PrivateLeaseBreakdown.financePlan")}
            price={paymentType}
            style={`${this.getRowColor()} ${styles.rightIndent} ${
              styles.rightAlign
            }`}
            rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
          />
          <SpecsRow
            priceDetails={this.props.t(
              "PrivateLeaseBreakdown.monthlyInstallmentAmount"
            )}
            price={this.formatPriceValue(
              financeDataQuote.monthlyPaymentWithoutInclusiveFee
            )}
            style={`${this.getRowColor()} ${styles.rightIndent} ${
              styles.rightAlign
            }`}
            rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
          />

          <SpecsRow
            priceDetails={this.props.t(
              "PrivateLeaseBreakdown.numberOfMonthlyPayments"
            )}
            price={financeDataQuote.numberOfPayments}
            style={`${this.getRowColor()} ${styles.rightIndent} ${
              styles.rightAlign
            }`}
            rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
          />
          <SpecsRow
            priceDetails={this.props.t("PrivateLeaseBreakdown.term")}
            price={financeDataQuote.term}
            style={`${this.getRowColor()} ${styles.rightIndent} ${
              styles.rightAlign
            }`}
            rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
          />

          <SpecsRow
            priceDetails={this.props.t("PrivateLeaseBreakdown.deposit")}
            price={this.formatPriceValue(financeDataQuote.deposit)}
            style={`${this.getRowColor()} ${styles.rightIndent} ${
              styles.rightAlign
            }`}
            rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
          />
          <SpecsRow
            priceDetails={this.props.t("PrivateLeaseBreakdown.annualMileage")}
            price={
              financeDataQuote.annualMileage
                ? financeDataQuote.annualMileage
                : "--"
            }
            style={`${this.getRowColor()} ${styles.rightIndent} ${
              styles.rightAlign
            }`}
            rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
          />

          <SpecsRow
            priceDetails={this.props.t("PrivateLeaseBreakdown.interestRate")}
            price={
              financeDataQuote.interestRate
                ? financeDataQuote.interestRate + "%"
                : "--"
            }
            style={`${this.getRowColor()} ${styles.rightIndent} ${
              styles.rightAlign
            }`}
            rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
          />
          <SpecsRow
            priceDetails={this.props.t("PrivateLeaseBreakdown.apr")}
            price={financeDataQuote.apr ? financeDataQuote.apr + "%" : "--"}
            style={`${this.getRowColor()} ${styles.rightIndent} ${
              styles.rightAlign
            }`}
            rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
          />

          <SpecsRow
            priceDetails={this.props.t("PrivateLeaseBreakdown.amountToFinance")}
            price={this.formatPriceValue(financeDataQuote.totalAmountPayable)}
            style={`${this.getRowColor()} ${styles.rightIndent} ${
              styles.rightAlign
            }`}
            rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
          />
          <SpecsRow
            priceDetails={this.props.t(
              "PrivateLeaseBreakdown.expectedFullAmount"
            )}
            price={this.formatPriceValue(financeDataQuote.monthlyPayments)}
            style={`${this.getRowColor()} ${styles.rightIndent} ${
              styles.rightAlign
            }`}
            rowStyle={`${styles.mediumIndent} ${styles.itemHeaderText} ${styles.leftAlign}`}
          />
        </div>
      </StyledBasicExpansionPanel>
    );
  }
}

export default withTranslation("emp")(PrivateLeaseBreakdown);
